import React from 'react'
import UniversityDetails from '../../components/HomeTabs/UniversityDetails'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { BackArrowIcon } from '../../icons'
import TotalUniversitiesSummaryCards from '../../components/TotalUniversitiesSummaryCards'
import AreaChartComponent from '../../components/AreaChartComponent'
const Home = () => {
  return (
    <>
      <Box sx={{ background: '#fff', }}>
 <TotalUniversitiesSummaryCards />
 <AreaChartComponent />
      </Box> 
    </>
  )
}

export default Home
